import {config as numberColumnConfig} from '../../common/NumberColumn';

export const prop = 'cRRetrn';

export const config = (labels) =>
	numberColumnConfig({id: 'returned', label: labels.returned, width: 'minmax(var(--px-140), 1fr)', prop});
